(function() {
  'use strict';

    //*****************//
    // Data that this directive needs
    // -----------------
    // 
    //*****************//
    // Requires the tenant 
    // 
    // }

    function pxAlertNotification($location, TenantListService, SYSTEM_ISSUES, EventServiceEvents, $http, toastr, $filter) {
      return {
        restrict: 'E',
        scope: {},
        templateUrl: 'app/directives/alertNotification/alert-notification.template.html',
        link: function(scope) {
  
          scope.showAlertNotification = false;
          scope.hideAlertHint = true;
          scope.currentTenant = null;
          scope.dismissAbleIssue = null;
          scope.issues = [];

          (function() {
            setListeners()
          })();

          scope.$watch(function(){
            return TenantListService
          }, function() {
            if (TenantListService.currentTenant) {
              scope.currentTenant = TenantListService.currentTenant;
              mapIssuesForRendering(scope.currentTenant.info._embedded.openIssues);
            }
          }, true)
          
          function mapIssuesForRendering(issuesRaw) {
            var issues = [];
            scope.issues = [];
            angular.forEach(issuesRaw, function(issueRaw) {
              var issue = angular.copy(SYSTEM_ISSUES[issueRaw.type])
              if (issue) {
                if (issue.type === 'GROUP_SYNCHRONIZATION_STOPPED') {
                  issue.provider = issueRaw.provider;
                  issue.tab = issueRaw.provider;
                }
                issue.id = issueRaw._links.self.href;
                issues.push(issue)
              }
            })
            evaluateIssuesList(removeDuplicates(issues));
          }

          function removeDuplicates(issues){ 
            var newIssuesArray = [];
            angular.forEach(issues, function(value, key) {
              var exists = false;
              angular.forEach(newIssuesArray, function(val2, key) {
                if(angular.equals(value.tab, val2.tab)) {
                   exists = true }; 
              });
              if(exists == false && value.tab != "") { 
                newIssuesArray.push(value); 
              }
            });
          
            return newIssuesArray;
          }

          function evaluateIssuesList (issues) {
            if (issues.length > 0) {
              scope.issues = issues;
              scope.hideAlertHint = false;
            } else {
              scope.hideAlertHint = true;
              scope.showAlertNotification = false;
            }
          }

          function removeResolvedIssue (issueId) {
            for (var i = 0; i < scope.currentTenant.info._embedded.openIssues.length; i++) {
              if (scope.currentTenant.info._embedded.openIssues[i]._links.self.href === issueId) {
                scope.currentTenant.info._embedded.openIssues.splice(i , 1);
              }
            }

            if (scope.currentTenant.info._embedded.openIssues.length === 0) {
              scope.currentTenant.info._embedded.openIssues = [];
            }
            mapIssuesForRendering(scope.currentTenant.info._embedded.openIssues);
          }

          scope.openAlertNotificationDialog = function () {
            scope.hideAlertHint = true;
            scope.showAlertNotification = true;
          }

          scope.hideAlertNotification = function () {
            scope.hideAlertHint = false;
            scope.showAlertNotification = false;
          }
          
          scope.gotoIssue = function(page, param, tab) {
            scope.hideAlertHint = false;
            scope.showAlertNotification = false;
            $location.path(page).search(param, tab);
          }

          scope.showDismissIssueWarning = function (event, issue) {
            event.stopPropagation();
            scope.clearPopups();
            scope.dismissAbleIssue = issue;
            
            scope.dismissIssueConfigurations = {
              confirm: 'Yes',
              warning: null,
              danger: true,
              cancel: 'No',
              validationString: null
            };
  
            scope.dismissIssuePopupObject = {
              dimensions: { height: 85, width: 250 },
              offset: { top: 35, left: 205 },
              pointerDirection: null,
              pointerPosition: 'left',
              relativePosition: 'over',
              absoluteX: event.clientX,
              absoluteY: event.clientY,
              type: 'CONFIRM',
              title: 'DismissIssue',
              confirmText: null,
              clickOutsideToClose: true
            }
          }
  
          scope.clearPopups = function () {
            scope.dismissIssueConfigurations = null;
            scope.dismissIssuePopupObject = null;
            scope.dismissAbleIssue = null;
          }

          scope.dissmissIssue = function () {
            var url = scope.dismissAbleIssue.id;
            var patch = [{
              op: 'replace',
              path: '/open',
              value: false
            }]
            $http.patch(url, patch).then(function(response) {
              toastr.success($filter("translate")("ChangesSaved"));
            }).catch(function(error){
              toastr.error($filter("translate")("ERROR"));
            });

            scope.dismissAbleIssue = null;
          }

          function setListeners () {
            scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ISSUE_CREATED, function(name, data) {
              $http.get(data.issue).then(function(issue) {
                TenantListService.currentTenant.info._embedded.openIssues.push(issue.data);
                mapIssuesForRendering(TenantListService.currentTenant.info._embedded.openIssues);
              }).catch(function(error){});
            });
            
            scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ISSUE_UPDATED, function(name, data) {
              removeResolvedIssue(data.issue);
            });
          }

        }
      };
    }
    
    pxAlertNotification.$inject = ['$location', 'TenantListService', 'SYSTEM_ISSUES', 'EventServiceEvents', '$http', 'toastr', '$filter'];
    
    angular
      .module('printix-admin')
      .constant('SYSTEM_ISSUES', 
        {
          GROUP_SYNCHRONIZATION_STOPPED: {
            type: 'GROUP_SYNCHRONIZATION_STOPPED',
            provider: null,
            icon: 'icon-group',
            route: '/authentication',
            param: 'authenticationSection',
            tab: null,
            caption: 'GroupSynchronization',
            solvedAt: null,
            dismissedAt: null,
            id: null
          },
          CLOUD_STORAGE_BROKEN: {
            type: 'CLOUD_STORAGE_BROKEN',
            provider: null,
            icon: 'icon-cloud',
            route: '/settings',
            param: 'settingsSection',
            tab: 'cloudStorage',
            caption: 'CloudStorage',
            solvedAt: null,
            dismissedAt: null,
            id: null
          },
          PAYMENT_FAILED: {
            type: 'PAYMENT_FAILED',
            provider: null,
            icon: 'icon-credit-card',
            route: '/subscription',
            param: 'subscriptionSection',
            tab: 'cardTransactions',
            caption: 'Payments',
            solvedAt: null,
            dismissedAt: null,
            id: null
          },
          CREDIT_CARD_PAYMENT_FAILED: {
            type: 'CREDIT_CARD_PAYMENT_FAILED',
            provider: null,
            icon: 'icon-credit-card',
            route: '/subscription',
            param: 'subscriptionSection',
            tab: 'cardTransactions',
            caption: 'Payments',
            solvedAt: null,
            dismissedAt: null,
            id: null
          },
          DATA_EXTRACT_FAILED: {
            type: 'DATA_EXTRACT_FAILED',
            provider: null,
            icon: 'icon-analytics',
            route: '/settings',
            param: 'settingsSection',
            tab: 'analytics',
            caption: 'DataExtract',
            solvedAt: null,
            dismissedAt: null, 
            id: null
          }
        }
      )
      .directive('pxAlertNotification', pxAlertNotification);
  
})();